import { css, SerializedStyles } from '@emotion/core';
import {
  Theme,
  titleText,
  helpText,
  normalText,
  secondaryText,
} from 'features/Theme';

const styles = {
  breadSubtitle: (theme: Theme): SerializedStyles => css`
    text-align: center;
    margin-bottom: ${theme.mui.spacing(2)}px;
    font-size: ${normalText(theme)};
    div,
    span {
      display: inline-block;
    }
    span {
      vertical-align: top;
    }
    svg {
      height: 22.5px;
      width: auto;
      margin-left: ${theme.mui.spacing(0.5)}px;
    }
  `,

  creditCardTitleContainer: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(1)}px;
    display: flex;
    align-items: center;
  `,

  eligibilityCheckContainer: (theme: Theme): SerializedStyles => css`
    ${secondaryText(theme)};
    text-align: center;
    margin-bottom: ${theme.mui.spacing(2)}px;
  `,
  pageTitleText: (theme: Theme): SerializedStyles => css`
    ${titleText(theme)}
    text-align: center;
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,

  finePrint: (theme: Theme): SerializedStyles => css`
    margin-top: ${theme.mui.spacing(3)}px;
    p {
      ${helpText(theme)};
      margin-bottom: ${theme.mui.spacing(1)}px;
      color: ${theme.mui.palette.text.secondary};
    }
  `,
  normalText: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)};
  `,
  subTitleText: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)};
    text-align: center;
  `,
  paymentOptionText: (theme: Theme): SerializedStyles => css`
    ${secondaryText(theme)};
  `,
  divider: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  installmentPlanMessage: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  installmentOffer: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  paymentOptionContainer: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  paymentOptionBreadTitle: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(1)}px;
    display: flex;
    align-items: center;
    svg {
      height: 22.5px;
      width: auto;
      margin-top: 2.5px;
      margin-right: ${theme.mui.spacing(0.75)}px;
    }
  `,
  paymentOptionTitleText: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)};
  `,
  fixedIntendedPurchaseAmount: (theme: Theme): SerializedStyles => css`
    display: flex;
    justify-content: center;
    ${titleText(theme)}
  `,
  semiBold: css`
    font-weight: 600;
  `,
  splitPayPaymentsMessage: (theme: Theme): SerializedStyles => css`
    font-weight: 600;
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,

  bigMoney: (theme: Theme): SerializedStyles => css`
    ${titleText(theme)};
    color: ${theme.mui.palette.primary.main};
  `,

  enquiryIcon: (theme: Theme): SerializedStyles => css`
    vertical-align: bottom;
    color: ${theme.mui.palette.primary.main};
    .MuiSvgIcon-root {
      vertical-align: bottom;
      font-size: 15px;
      padding: 12.5px;
      margin: -10px;
    }
  `,

  stepperContainer: (theme: Theme): SerializedStyles => css`
    margin-bottom: -${theme.mui.spacing(2)}px;
    .MuiPaper-root.MuiStepper-root.MuiStepper-vertical {
      padding: 0;
    }
  `,
  stepper: css`
    .MuiStepConnector-root {
      margin-bottom: -8px;
    }
  `,
  stepCircle: (theme: Theme): SerializedStyles => css`
    color: ${theme.mui.palette.primary.main};
  `,
  stepConnector: (theme: Theme): SerializedStyles => css`
    .MuiStepConnector-line {
      width: 0;
      border-radius: 1px;
      opacity: 38%;
      border: 1px solid ${theme.mui.palette.primary.main};
      margin-left: -1px;
    }
  `,
  stepPrice: (theme: Theme): SerializedStyles => css`
    color: ${theme.mui.palette.primary.main};
  `,
  breadIcon: css`
    height: 18px;
    margin-bottom: 2px;
  `,
  cardIcon: (theme: Theme): SerializedStyles => css`
    height: 20px;
    padding-left: ${theme.mui.spacing(0.75)}px;
  `,
  footer: (theme: Theme) => css`
    padding-top: ${theme.mui.spacing(3)}px;
    padding-bottom: ${theme.mui.spacing(1)}px;
  `,
  intendedPurchaseAmount: (theme: Theme) => css`
    display: flex;
    justify-content: center;
    margin-top: ${theme.mui.spacing(1)}px;
  `,
};

export default styles;
